import instance, { customConfig } from "../../../Utils/Interceptors/Interceptor";

const ObtenerArchivosSinInformar = async (values) => {
    try {
        const resultado = await instance.Backend.post("/InformeConservacion/ObtenerArchivosSinInformar",values, customConfig);

        return resultado

    } catch (error) {

        console.log(error);

    }

}
export { ObtenerArchivosSinInformar };
